var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89307 14.579C4.89307 14.1648 5.22885 13.829 5.64307 13.829H10.7859C11.2001 13.829 11.5359 14.1648 11.5359 14.579C11.5359 14.9933 11.2001 15.329 10.7859 15.329H5.64307C5.22885 15.329 4.89307 14.9933 4.89307 14.579Z",
    fill: "#2F363D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64307 8.68616C5.22885 8.68616 4.89307 9.02194 4.89307 9.43616C4.89307 9.85037 5.22885 10.1862 5.64307 10.1862H10.7859C11.2001 10.1862 11.5359 9.85037 11.5359 9.43616C11.5359 9.02194 11.2001 8.68616 10.7859 8.68616H5.64307Z",
    fill: "#2F363D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.72069 0.300314C8.00346 0.0528903 8.42567 0.0528903 8.70844 0.300314L15.5656 6.30031C15.7283 6.44273 15.8217 6.64847 15.8217 6.86475V10.4005H23.6431C24.0573 10.4005 24.3931 10.7362 24.3931 11.1505V23.1505C24.3931 23.5647 24.0573 23.9005 23.6431 23.9005H15.0755L15.0717 23.9005H8.2169L8.21448 23.9005L8.21206 23.9005H1.35742C0.943208 23.9005 0.607422 23.5647 0.607422 23.1505V6.86475C0.607422 6.64847 0.700782 6.44273 0.863543 6.30031L7.72069 0.300314ZM8.96448 22.4005V19.7219C8.96448 19.3077 8.62869 18.9719 8.21448 18.9719C7.80026 18.9719 7.46448 19.3077 7.46448 19.7219V22.4005H2.10742V7.20507L8.21456 1.86132L14.3217 7.20507V11.1415L14.3217 11.1505L14.3217 11.1594V22.4005H8.96448ZM22.8931 11.9005H15.8217V22.4005H22.8931V11.9005Z",
    fill: "#2F363D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany2);
export default __webpack_public_path__ + "static/media/company-2.4fd045a266035217245a0d13065b1eaf.svg";
export { ForwardRef as ReactComponent };